import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=61644066&"
import script from "./PaginationButton.vue?vue&type=script&lang=ts&"
export * from "./PaginationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports